import React from 'react';
import './ErrorBoundary.css';

interface PanelErrorFallbackProps {
  error: Error | null;
  onRetry: () => void;
  panelName?: string;
}

const PanelErrorFallback: React.FC<PanelErrorFallbackProps> = ({ error, onRetry, panelName = 'Panel' }) => {
  return (
    <div className="error-boundary-fallback panel-error-fallback">
      <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="8" x2="12" y2="12" />
        <line x1="12" y1="16" x2="12.01" y2="16" />
      </svg>
      <h3>{panelName} Error</h3>
      <p>{error?.message || 'An unexpected error occurred.'}</p>
      <button onClick={onRetry}>Retry</button>
    </div>
  );
};

export default PanelErrorFallback;
